export enum CodigoParametro {
    RecaudadorMetlife = 'RECAUDADOR_METLIFE',
}

export enum SiNo {
    SI = 'Y',
    NO = 'N'
}

export enum TipoTablaDesarrollo {
    CuotaMinima,
    CuotaMaxima
}

export enum enumTipoParticipante {
    Deudor = "DEUDOR",
    Codeudor = "CODEUDOR",
    Mandatario = "MANDATARIO",
    Conyuge = "CONYUGE"
}

export enum enumTipoParticipanteConValores {
    Deudor = 0,
    Codeudor,
    Mandatario,
    Conyuge,
    DeudorJuridico
}

export enum enumTipoPersona {
    Natural = "N",
    Juridica = "J"
}

export enum enumTipoSeguro {
    DESGRAVAMEN
}
export enum enumTipoSeguroConValores {
    DESGRAVAMEN = 'DESGRAVAMEN',
    CESANTIA = 'CESANTIA',
    INCENDIO = 'INCENDIO'
}

export enum EnumCodeudor {
    CoTitular = "CO-TITULAR",
    CodeudorTitular = "CO-DEU-TIT"
}

export enum EnumDestinoCredito {
    Adquisicion = 'A',
    OtroFinesGenerales = 'O',
    Refinanciamiento = 'F',
    Construccion = 'C',
    Prepago = '6',
    ReparacionAmpliacion = 'R'
}

export enum TipoProducto {
    MHT = 'MHT',
    MHF = 'MHF',
    MHD = 'MHD'
}

export enum TipoProductoValores {
    MHT = "7",
    MHF = "6",
    MHD = "5"
}

export enum TipoSeguro {
    DESGRAVAMEN = 'DESGRAVAMEN',
    INCENDIO = 'INCENDIO',
    CESANTIA = 'CESANTIA'
}

export enum Dominios {
    ESTADO_CIVIL = "ESTADO_CIVIL",
    TIPO_DEUDA = "TIPO_DEUDA",
    UTILIDAD = "UTILIDAD",
    CANAL_VENTA = "CANAL_VENTA",
    DFL2 = "DFL2",
    PREPAGO = "PREPAGO",
    TIPO_BENEFICIARIO = "TIPO_BENEFICIARIO",
    BENEFICIOS_SII = "BENEFICIOS_SII",
    REFINANCIAMIENTO = "REFINANCIAMIENTO",
    ADQUISICION = "ADQUISICION",
    TABLAS_DESARROLLO_BASE_TASA = "TABLAS_DESARROLLO_BASE_TASA",
    TIPO_PROPIEDAD = "TIPO_PROPIEDAD",
    TIPO_SEGURO = 'TIPO_SEGURO',
    TIPO_RESPONSABLE = 'TIPO_RESPONSABLE',
    ACCION_CONTABLE = 'ACCION_CONTABLE',
    RECAUDACION_FORMA_PAGO = 'RECAUDACION_FORMA_PAGO',
    EMPRESA_COBRANZA = 'EMPRESA_COBRANZA',
    EMISOR = 'EMISOR',
    ESTADO_PAC = 'ESTADO_PAC',
    BANCO = 'BANCO',
    DIA_COBRO = 'DIA_COBRO',
    TIPO_CUOTA = 'TIPO_CUOTA',
    TIPO_MONEDA = 'TIPO_MONEDA',
    TIPO_TARJETA = 'TIPO_TARJETA',
    ESTADO_BEN_MINVU = "ESTADO_BEN_MINVU",
    ESTADO_COBRO_MINVU = "ESTADO_COBRO_MINVU",
    ESTADO_SEGURO_MINVU = "ESTADO_SEGURO_MINVU",
    DESTINO_REMESAS = "DESTINO_REMESAS",
    COMPAÑIA_SEGUROS = "COMPAÑIA_SEGUROS",

}

export enum TipoPropiedad {
    Nueva = "NUEVA",
    Usada = "USADA"
}

export enum TipoDireccion {
    PARTICULAR = "PARTICULAR",
    CORRESPONDENCIA = "CORRESPOND",
    PARTICULAR_CONYUGE = "PARCONYUGE",
    CORRESPONDENCIA_CONYUGE = "CORCONYUGE",
    PARTICULAR_MANDATARIO = "PARMANDAJUD",
    PARTICULAR_SEGUNDO_MANDATARIO = "PARSGMANDJUD",
    PARTICULAR_CODEUDOR = "PARCODEUDOR"
}

export enum CodigoEnum {
    CO_TITULAR = "CO-TITULAR",
    CO_CODEUDOR = "CO-DEUDOR",
    AVAL = "AVAL",
    GARANTE_HIPOTECARIO = "GAR-HIP",
    NO_ES_CODEUDOR = "NO ES CODEUDOR",
}

export enum StatusCode {
    Ok = 200,
    Created = 201,
    NoContent = 204,
    BadRequest = 400,
    InternalServer = 500
}

export enum TipoBienRaiz {
    NO_SE_REGISTRA = 0,
    BODEGAS = 1,
    CASAS = 2,
    DEPARTAMENTOS = 3,
    ESTACIONAMIENTO = 4,
    TERRENOS = 5,
    LOCAL_COMERCIAL = 6,
    FUNDOS = 7,
    OFICINA = 8,
    CONST_INDUST = 9,
    GALPONES = 10,
    PARCELA_AGRAD = 11
}

export enum TipoMutuo {
    Complementario = 'COMPLE',
    Normal = 'NORMAL'
}
export enum EnumTasacion {
    ValorMaximoTasacion = 80
}

export enum EnumTipoEstadoRegistro {
    Todas = "T",
    Activo = "Y",
    Inactivo = "N"
}
export enum EstadoRegistro {
    Todas = "Todas",
    Activo = "Activo",
    Inactivo = "Inactivo"
}

export enum EnumEstadoMutuo {
    Aprobado = "APROBADO",
    Ingresado = "INGRESADO",
    Pre_Ingresado = "PREINGRESADO",
    Por_Ingresar = "Por Ingresar",
    Activado = "ACTIVADO",
    Liquidado = "LIQUIDADO",
    Endosado = "ENDOSADO",
}

export enum Prepago {
    ConCosto = "Con costo",
    SinCosto = "Sin costo"
}

export enum OrigenDetalleMutuo {
    BandejaMutuo = 'bandeja-mutuo',
    CarteraTotal = 'cartera-mutuos',
}
export enum FiltroMovimientoContable {
    Todas = "Todas"
}

export enum FormaPago {
    Documento = 'DOCUMENTO'
}

export enum TipoArchivo {
    TIPOARCHIVOMINVU_VALIDACION = "VALIDACION",
    TIPOARCHIVOMINVU_COBRO = "COBRO",
}

export enum EstadoSubsidioMinvu {
    ESTADOSUBSIDIOMINVU_NOGENERADO = "NOGENERADO",
    ESTADOSUBSIDIOMINVU_GENERADO = "GENERADO",
    ESTADOSUBSIDIOMINVU_DESCARGADO = "DESCARGADO",
    ESTADOSUBSIDIOMINVU_ENVIADO = "ENVIADO",
    ESTADOSUBSIDIOMINVU_VALIDADO = "VALIDADO",
    ESTADOSUBSIDIOMINVU_NOVALIDADO = "NOVALIDADO",
}

export enum EstadoSubsidioMinvuCobro {
    ESTADO_COBRO_MINVU_NOENVIADO = "NOENVIADO",
    ESTADO_COBRO_MINVU_ENVIADO = "ENVIADO",
    ESTADO_COBRO_MINVU_DESCARGADO = "DESCARGADO",
    ESTADO_COBRO_MINVU_GENERADO = "GENERADO",
    ESTADO_COBRO_MINVU_ACEPTADO = "ACEPTADO",
    ESTADO_COBRO_MINVU_RECHAZADO = "RECHAZADO",
}

export enum EntidadRecaudadora {
    PACBCI = "99999999-9",
    PATREC = "77777777-7"
}

export enum SeguroMinvu {
    ESTADOSEGUROMINVU_NO_COBRADO = "No Cobrado",
    ESTADOSEGUROMINVU_COBRADO = "Cobrado"
}

export enum DestinoRemesas {
    Inversionista = 1,
    CompaniaSeguros = 2
}

export enum EstadoSolicitudPrepago {
    GENERADA = "Generada",
    LIQUIDADO = "Liquidada",
    RECAUDADA = "Recaudada"
}

export enum EstadoProcesoCarga {
    INICIO = "INICIO",
    TERMINO = "TERMINO",
    ERROR = "ERROR"
}

export enum TipoFuncionalidad {
    Bandeja_ver = "BANDEJA_VER",
    Bandeja_ingresar = "BANDEJA_INGRESAR",
    Bandeja_editar = "BANDEJA_EDITAR",
    Activar_mutuo = "ACTIVAR_MUTUO",
    Bandeja_aprobar = "BANDEJA_APROBAR",
    Cartera_ver = "CARTERA_VER",
    // Cartera_editar = "CARTERA_EDITAR_MUTUO",
    Administrar_liquidacion = "CARTERA_ADM_LIQUIDACION",
    Administrar_prepago = "CARTERA_ADM_PREPAGO",
    Desactivar_mutuo = "DESACTIVAR_MUTUO",
    Endoso_masivo = "ENDOSO_ADM",
    Remesas_ADM = "REMESAS_ADM",
    Recaudacion_ver = "RECAUDACION_VER",
    Recaudacion_adm = "RECAUDACION_ADM",
    Cobranza_ver = "COBRANZA_VER",
    Cobranza_adm = "COBRANZA_ADM",
    Contabilidad_ver = "CONTA_VER",
    Contailidad_ADM = "CONTA_ADM",
    Minvu_ADM = "MINVU",
    Reporte_consultas = "REPORTES_CONSULTAS",
    Informe_CMF = "REPORTES_CMF",
    Reportes_portabilidad = "REPORTES_PORTABILIDAD",
    SII = "REPORTES_SII",
    Ejecutar_query = "EJECUTAR_QUERYS",
    Maestros_ver = "MAESTROS_VER",
    Maestros_editar = "MAESTROS_EDITAR",
    Cobranza_adm_cesantes = "COBRANZA_ADM_CESANTES",
    Conta_ver_Divs = "CONTA_VER_DIVS",
    Conta_ver_movs = "CONTA_VER_MOVS",
    Reportes_CMF = "REPORTES_CMF",
    Reportes_SII = "REPORTES_SII",
    Maestros_ver_td = "MAESTROS_VER_TD",
    Cartera_editar_info = "CARTERA_EDITAR_INFO",
    Cartera_editar_contacto = "CARTERA_EDITAR_CONTACTO",
    Cartera_liq_ver = "CARTERA_LIQ_VER",
    Cartera_prep_ver = "CARTERA_PREP_VER",
    Cartera_adm_cobranza = "CARTERA_ADM_COBRANZA",
    Cartera_gen_sol_prepago = "CARTERA_GEN_SOL_PREPAGO",
    Cartera_adm_prepago = "CARTERA_ADM_PREPAGO",
    Transversal_exportar = "TRANSVERSAL_EXPORTAR",
    Cartera_adm_dividendos = "CARTERA_ADM_DIVIDENDOS",
    Cartera_gen_dividendos = 'CARTERA_GEN_DIVIDENDOS',
    Extinguir_mutuo = 'EXTINGUIR_MUTUO',
}
